import React from 'react';

import styled from 'styled-components';

import Select from 'components/lib/Select';

import {
  REVIEW_ALERT_REVIEW_COUNT_OPTIONS,
  REVIEW_ALERT_SENTIMENT_OPTIONS,
  REVIEW_ALERT_WITHIN_OPTIONS,
} from './constants';

const FiltersRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 10px;
`;

const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  min-width: 0;
`;

const FilterLabel = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
`;

const StyledSelect = styled(Select)`
  width: 100%;
`;

type Props = {
  reviewCount: number;
  sentiment: boolean;
  withinMonths: number;
  onReviewCountChange: (value: number) => void;
  onSentimentChange: (value: boolean) => void;
  onWithinMonthsChange: (value: number) => void;
};

const CommunityReviewAlertModeFilters = ({
  reviewCount,
  sentiment,
  withinMonths,
  onReviewCountChange,
  onSentimentChange,
  onWithinMonthsChange,
}: Props) => {
  return (
    <FiltersRow>
      <FilterItem>
        <FilterLabel>Review Count</FilterLabel>
        <StyledSelect
          className="rectangular"
          value={reviewCount}
          options={REVIEW_ALERT_REVIEW_COUNT_OPTIONS}
          onChange={(value) => onReviewCountChange(Number(value))}
        />
      </FilterItem>
      <FilterItem>
        <FilterLabel>Sentiment</FilterLabel>
        <StyledSelect
          className="rectangular"
          value={sentiment ? 1 : 0}
          options={REVIEW_ALERT_SENTIMENT_OPTIONS}
          onChange={(value) => onSentimentChange(Number(value) === 1)}
        />
      </FilterItem>
      <FilterItem>
        <FilterLabel>Within</FilterLabel>
        <StyledSelect
          className="rectangular"
          value={withinMonths}
          options={REVIEW_ALERT_WITHIN_OPTIONS}
          onChange={(value) => onWithinMonthsChange(Number(value))}
        />
      </FilterItem>
    </FiltersRow>
  );
};

export default CommunityReviewAlertModeFilters;
